import React from 'react';

import { TSvgIcon } from '../types';

export const Order2Icon: TSvgIcon = ({ width = 80, height = 77 }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 80 77" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M33.6278 0.0316889C43.0895 0.592052 52.8731 4.34667 57.5832 12.6245C62.4339 21.1495 60.5934 31.6042 56.7245 40.6235C52.8405 49.6782 46.5813 58.4027 37.0198 60.563C27.7921 62.648 19.0773 56.925 11.8742 50.757C5.41935 45.2297 0.326227 37.8228 0.504543 29.295C0.672505 21.2624 6.7277 15.2683 12.7271 9.96794C18.8193 4.58569 25.5354 -0.447579 33.6278 0.0316889Z"
                fill="#090089"
            />
            <path
                d="M54.3454 10.1393C63.7458 12.3747 71.4285 18.7724 75.6247 27.2856C79.6869 35.5269 79.2145 44.907 75.6519 53.3658C71.9093 62.2519 65.5659 69.9893 56.2898 73.1936C45.8689 76.7934 33.3692 77.7988 24.8573 70.9121C16.599 64.2305 17.4277 52.3711 17.6111 41.8997C17.7809 32.2058 18.3954 21.8713 25.8289 15.4443C33.4512 8.85404 44.4539 7.7871 54.3454 10.1393Z"
                fill="#FD397A"
            />
            <rect x="9.5" y="5" width="65" height="65" rx="32.5" fill="#00D9DE" />
            <path
                d="M55.046 37.44L43.046 25.44C42.566 24.96 41.8993 24.6666 41.166 24.6666H31.8327C30.366 24.6666 29.166 25.8666 29.166 27.3333V36.6666C29.166 37.4 29.4593 38.0666 29.9527 38.56L41.9527 50.56C42.4327 51.04 43.0993 51.3333 43.8327 51.3333C44.566 51.3333 45.2327 51.04 45.7127 50.5466L55.046 41.2133C55.5393 40.7333 55.8327 40.0666 55.8327 39.3333C55.8327 38.6 55.526 37.92 55.046 37.44ZM33.8327 31.3333C32.726 31.3333 31.8327 30.44 31.8327 29.3333C31.8327 28.2266 32.726 27.3333 33.8327 27.3333C34.9393 27.3333 35.8327 28.2266 35.8327 29.3333C35.8327 30.44 34.9393 31.3333 33.8327 31.3333Z"
                fill="white"
            />
        </svg>
    );
};
